import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73ece8e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-spinner" }
const _hoisted_2 = {
  height: "100%",
  "stroke-miterlimit": "10",
  style: {"fill-rule":"nonzero","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"},
  version: "1.1",
  viewBox: "0 0 300 300",
  width: "100%",
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:vectornator": "http://vectornator.io",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  id: "_x35_997047a-69c2-432d-836c-d299ff0ddb69",
  "vectornator:layerName": "_x35_997047a-69c2-432d-836c-d299ff0ddb69"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M119.218 79.0275L119.218 220.973C119.218 229.415 132.372 229.415 132.372 220.973L132.372 79.0275C132.372 70.5854 119.218 70.5854 119.218 79.0275ZM167.613 79.0275L167.613 220.973C167.613 229.415 180.767 229.415 180.767 220.973L180.767 79.0275C180.767 70.5854 167.613 70.5854 167.613 79.0275Z",
    fill: "#ffffff",
    "fill-rule": "nonzero",
    opacity: "1",
    stroke: "none"
  })
], -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
  ]))
}